export const usePdpCanonicalUrl = () => {
  const route = useRoute();
  const config = useRuntimeConfig();

  return `${config.public.apiBaseUrl.replace(/\/$/, '')}${route.fullPath.split('?')[0]}`;
};
